import { useServerSideFilters } from "@/hooks/useQueryFilters";
import { accountingTransactionsTodosFilter } from "../utils/transactions-todos-filter";
import { useTransactionsLiveCountsSubscription } from "./live-counts";

export const useAccountingTransactionsTodosLiveCount = () => {
  const serverSideQuery = useServerSideFilters({
    query: accountingTransactionsTodosFilter,
  });

  const { liveCounts, loading } = useTransactionsLiveCountsSubscription({
    query: serverSideQuery,
  });

  return { liveCounts, loading };
};
